import http from '@/support/plugin/axios'

export const 

//Ofertas
getUserPrizeByCompanyIdAndCurrentContactIdAndId = ( companyId, prizeId ) => http.get(`/companies/${companyId}/contacts/current/prizes/${prizeId}`),

//Recompensas
getLoyaltyPrizeByCompanyIdAndCurrentContactIdAndId = ( companyId, prizeId ) => http.get(`/companies/${companyId}/contacts/current/loyalty/prizes/${prizeId}`)